import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ToastProvider = () => <ToastContainer className="!tw-z-[2000000002]" />;

export default ToastProvider;
